import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

interface Props {
  title?: string;
  actions?: ReactNode;
  children: ReactNode;
}

const styles = {
  module: {
    border: '1px solid',
    borderColor: Colors.ArmyGreen200,
    borderRadius: '8px',
    padding: 'padding_24',
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 'padding_16',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    gap: 'padding_8',
  },
};

export const AccountSettingsModule = ({ title, actions, children }: Props) => {
  const hasHeader = Boolean(title || actions);

  return (
    <Box sx={styles.module}>
      {hasHeader && (
        <FlexRow sx={styles.header}>
          {title ? <Text.Lead>{title}</Text.Lead> : <Box />}
          {actions && <Box sx={styles.actions}>{actions}</Box>}
        </FlexRow>
      )}
      {children}
    </Box>
  );
};
